import { FORMATION_CODES } from '../data/positions.ts';
import { useSquad } from '../lib/squadContext.ts';
import { C } from '../lib/theme.ts';
import DepthChart from './DepthChart.tsx';
import Pitch from './Pitch.tsx';
import UefaLists from './UefaLists.tsx';

/** Shared styling for the three action buttons in the section header. */
const headerButton = {
  fontSize: 10,
  fontWeight: 800,
  letterSpacing: '0.1em',
  padding: '5px 10px',
  cursor: 'pointer',
} as const;

/** Full-width tactics section: formation strip, pitch, depth chart and UEFA lists. */
export default function TacticsPanel() {
  const { state, dispatch } = useSquad();

  return (
    <section
      style={{
        gridColumn: '1 / -1',
        order: 4,
        borderBottom: `2px solid ${C.ink}`,
        background: C.bg,
        minWidth: 0,
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '11px 16px',
          borderBottom: `2px solid ${C.ink}`,
          background: C.surface,
        }}
      >
        <span style={{ fontSize: 11, fontWeight: 800, letterSpacing: '0.16em' }}>
          TAKTİK &amp; KADRO DERİNLİĞİ
        </span>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <button
            onClick={() => dispatch({ type: 'clearLineup' })}
            style={{
              border: `2px solid ${C.ink}`,
              background: C.bg,
              color: C.ink,
              ...headerButton,
            }}
          >
            TEMİZLE
          </button>
          <button
            onClick={() => dispatch({ type: 'autoFillLineup' })}
            style={{
              border: `2px solid ${C.ink}`,
              background: C.ink,
              color: C.bg,
              ...headerButton,
            }}
          >
            EN İYİ 11
          </button>
          <button
            onClick={() => dispatch({ type: 'setPoster', open: true })}
            style={{
              border: `2px solid ${C.red}`,
              background: C.red,
              color: C.bg,
              ...headerButton,
            }}
          >
            ÖNİZLEME
          </button>
        </div>
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 0, borderBottom: `2px solid ${C.ink}` }}>
        {FORMATION_CODES.map((code) => {
          const active = state.formation === code;
          return (
            <button
              key={code}
              onClick={() => dispatch({ type: 'setFormation', formation: code })}
              style={{
                border: 0,
                borderRight: `1px solid ${C.line}`,
                background: active ? C.ink : C.bg,
                color: active ? C.bg : C.ink,
                fontSize: 11,
                fontWeight: 800,
                letterSpacing: '0.06em',
                padding: '9px 13px',
                cursor: 'pointer',
              }}
            >
              {code}
            </button>
          );
        })}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '380px 1fr' }}>
        <Pitch />
        <DepthChart />
      </div>

      <UefaLists />
    </section>
  );
}
